// extracted by mini-css-extract-plugin
export default {"layout":"AdminLayout_layout__ZKuCs","content":"AdminLayout_content__6GQOn","contentLayout":"AdminLayout_contentLayout__dVgxL","innerContent":"AdminLayout_innerContent__iDUy2"};